import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'

Vue.use(VueRouter)

const routes = [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login'),
    meta: { title: '厨娘·家宴 - 登录' }
  },
  {
    path: '/qrcode',
    name: 'qrcode',
    component: () => import('@/views/QrcodePoster'),
    meta: { title: '厨娘·家宴 - 二维码', requiresAuth: true }
  },
  {
    path: '/menu',
    name: 'menu',
    component: () => import('@/views/Menu'),
    meta: { title: '厨娘·家宴菜单' }
  },
  {
    path: '/expired',
    name: 'expired',
    component: () => import('@/views/Expired'),
    meta: { title: '页面已过期' }
  },
  {
    path: '/',
    redirect: '/login'
  },
  {
    path: '*',
    redirect: '/login'
  }
]

const router = new VueRouter({
  routes
})

// 全局路由守卫
router.beforeEach((to, from, next) => {
  // 设置页面标题
  if (to.meta.title) {
    document.title = to.meta.title
  }

  // 需要登录的路由：检查是否有 token
  if (to.meta.requiresAuth) {
    if (!store.getters.isAuthenticated) {
      // 未登录，跳转到登录页
      next({ path: '/login', query: { redirect: to.fullPath } })
      return
    }
  }

  // 菜单页面：检查过期时间
  if (to.name === 'menu') {
    const timeParam = to.query.time || to.query.t
    if (timeParam) {
      const menuTime = parseInt(timeParam, 10)
      const now = Date.now()
      const sevenDays = 7 * 24 * 60 * 60 * 1000

      // 如果传入的是秒级时间戳，转为毫秒
      const menuTimeMs = menuTime < 10000000000 ? menuTime * 1000 : menuTime

      if (now - menuTimeMs > sevenDays) {
        next({ path: '/expired' })
        return
      }
    }
  }

  next()
})

export default router
